import { OnboardingStep } from '../types';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';

export const useOnboardingWizardStepAnalyticsPage = (step: OnboardingStep) => {
  useAnalyticsPage(Page.ONBOARDING_WIZARD_STEP, { step: step });
};
